document.querySelectorAll('input, select, textarea').forEach(function (input) {
    input.addEventListener('invalid', function (e) {
        // prevent showing the default display
        e.preventDefault()
    })
});

function menuTrigger() {
    let actItem = $(".menu-btn");
    if (window.innerWidth < 886) {
        if (actItem.hasClass("active")) {
            actItem.removeClass("active");
            $(".main-menu").removeClass("open");
            hold_scroll_page(false);
        } else {
            actItem.addClass("active");
            $(".main-menu").addClass("open");
            hold_scroll_page(true);
        }
    }
}

function triggerFilter() {
    if ($(".map-filter").hasClass("open")) {
        $(".map-filter").removeClass("open");
        $(".sidebar-wrap").removeClass("open-filter");
    } else {
        $(".map-filter").addClass("open");
        $(".sidebar-wrap").addClass("open-filter");
    }
}

function triggerPlace() {
    if ($(".place-info").hasClass("open")) {
        $(".place-info").removeClass("open")
    } else {
        $(".place-info").addClass("open")
    }
}

function triggerSidebar() {
    if ($(".map-control").hasClass("hidden")) {
        $(".map-control").removeClass("hidden");
        $(".open-sidebar").removeClass("visible")
    } else {
        $(".map-control").addClass("hidden");
        $(".open-sidebar").addClass("visible")
    }
}

function seoButton() {
    if ($(".text-overflow").length) {
        if ($(".text-height").innerHeight() <= $(".text-overflow").innerHeight()) {
            $(".more-text").addClass("hide");
        } else {
            $(".more-text").removeClass("hide");
        }
    }
}

function searchTrigger() {
    if ($(".header-bottom").hasClass("open-search")) {
        if (!$('.search-form label input').val().length) {
            $(".header-bottom").removeClass("open-search");
            $(".header-search button").removeClass("open");
        } else {
            $(".header-bottom").removeClass("open-search");
            $(".header-search button").removeClass("open");
            $("body").removeClass("show-results");
            if (!$(".main-menu").hasClass("open")) {
                hold_scroll_page(false);
            }
        }
    } else {
        if (!$('.search-form label input').val().length) {
            $(".header-bottom").addClass("open-search");
            $(".header-search button").addClass("open");
        } else {
            $(".header-bottom").addClass("open-search");
            $(".header-search button").addClass("open");
            $("body").addClass("show-results");
            if (!$(".main-menu").hasClass("open")) {
                hold_scroll_page(true);
            }
        }
    }
}

function load_page(url) {
    $(".place-info").addClass("loading");
    $.get(url, function (data) {
        $data = $(data);
        $project_control = $('.place-wrap');
        $project_control.empty();
        $project_control.append($data.find('.place-content'));
    }, "html").done(function () {
        $(".place-info").removeClass("loading");
    });
    seoButton();


}


/*alert(d.toLocaleTimeString());*/
/*var n = $(".welcome-item.time");
var fi, pi, di, hi = n(278), mi = n.n(hi), vi = $(".welcome-item.time"), yi = 6e4, gi = 60 * yi,
    bi = yi / 5, wi = new Date,
    _i = (fi = wi, pi = new Date(fi.getFullYear(), 0, 1).getTimezoneOffset(), di = new Date(fi.getFullYear(), 6, 1).getTimezoneOffset(), Math.max(pi, di) !== fi.getTimezoneOffset() ? 3 : 2);

function xi() {
    var e, t, n,
        r = mi()((e = _i, t = new Date, n = t.getTime() + t.getTimezoneOffset() * yi, new Date(n + gi * e)), "HH:mm");
    vi && (vi.textContent = r)
}

xi(), setInterval(xi, bi);*/
var d = new Date();

function clock() {
    var hours = d.getHours();
    var minutes = d.getMinutes();


    if (hours <= 9) hours = "0" + hours;
    if (minutes <= 9) minutes = "0" + minutes;

    date_time = hours + ":" + minutes;
    if (document.layers) {
        document.layers.doc_time.document.write(date_time);
        document.layers.doc_time.document.close();
    } else {
        $(".welcome-item.time p span").text(date_time);
    }
}


function img_to_svg() {
    $(".svg-img:not(.replaced-svg) img").each(function () {
        var $img = $(this),
            imgID = $img.attr("id"),
            imgClass = $img.attr("class"),
            imgURL = $img.attr("src");
        $.get(imgURL, function (data) {
            var $svg = $(data).find("svg");
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + " replaced-svg");
            }

            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr("viewBox 0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
            }
            $img.replaceWith($svg);
        }, "xml");
    });
}


function fancyboxzoom(type) {

    var change = false;

    var w = $(".fancybox-content").width();
    var h = $(".fancybox-content").height();

    if (type === 'zoomin') {
        change = +150;
    }
    if (type === 'zoomout' && w > 300) {
        change = -150;
    }

    if (change) {
        var ratio = w / h;
        var nw = w + change;
        var nh = nw / ratio;
        $(".fancybox-content").width(nw);
        $(".fancybox-content").height(nh);

        var sw = window.innerWidth;
        var sh = window.innerHeight;

        if (nh < sh && nw < sw) {
            $(".fancybox-content").css({'transform': 'translate(' + (sw - nw) / 2 + 'px, ' + (sh - nh) / 2 + 'px)'});
        } else if (nw < sw) {
            $(".fancybox-content").css({'transform': 'translateX(' + (sw - nw) / 2 + 'px)'});
        }
    }
}
let USD_rate = undefined,
    EUR_rate = undefined;


function getCurrentDate() {
    var d = new Date();
    // return current_datetime.getFullYear().toString() + (prefix(current_datetime.getMonth() + 1)).toString() + prefix(current_datetime.getDate()).toString();   // Y-m-d
    return String(d.getFullYear()) + String(((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1))) + String(d.getDate())
}



$(document).ready(function () {
    img_to_svg();
    $("input[type=tel]").mask("+38 (099) 999-99-99");

    if ($('.twentytwenty-container').length > 0) {
        setTimeout(function() {
        var wBlock = parseInt($('.twentytwenty-container').css('width'));
        var slider_tw = $(".before-after").twentytwenty({
            before_label: $(".before-after").attr("data-before"),
            after_label: $(".before-after").attr("data-after")
        });
        /*slider_tw.on("move", function (e) {
            var w = parseInt($('.twentytwenty-handle', e.currentTarget).css('left'));
            if ((w / wBlock) * 100 < 35) {
                $(".twentytwenty-horizontal .twentytwenty-after-label").show();
                $(".twentytwenty-horizontal .twentytwenty-before-label").hide();
            } else if ((w / wBlock) * 100 > 65) {
                $(".twentytwenty-horizontal .twentytwenty-before-label").show();
                $(".twentytwenty-horizontal .twentytwenty-after-label").hide();
            } else {
                $(".twentytwenty-horizontal .twentytwenty-before-label").show();
                $(".twentytwenty-horizontal .twentytwenty-after-label").show();
            }
        });*/
        }, 300);
    }

    if ($(".welcome-item.time").length) {
        clock();
        setInterval("clock()", 2000);
        // $(".welcome-item.time p span").text(d.toLocaleTimeString());
    }

    if ($(".welcome-item.currency").length) {
        $.getJSON({
            url: `https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?date=${getCurrentDate()}&json`,
            async: false,
        }).done(data => {
            USD_rate = data.find(val => val.cc == "USD").rate;
            EUR_rate = data.find(val => val.cc == "EUR").rate;
            $(".welcome-item.currency").html("<p>$ " + USD_rate.toFixed(2) + " UAH</p><p>€ " + EUR_rate.toFixed(2) + " UAH</p>");
        });
    }

    if ($(".welcome-item.weather").length) {
        $.getJSON("http://api.openweathermap.org/data/2.5/find?q=Chernihiv,UA&units=metric&type=like&APPID=ed9cc7635c806d29531683b7ef016d90", function (data) {
            var iconcode = data.list[0].weather[0].icon;
            var iconurl = "http://openweathermap.org/img/w/" + iconcode + ".png";
            $(".welcome-item.weather").html("<p><span style='background-image: url(" + iconurl + ")'></span>" + data.list[0].main.temp.toFixed(0) + " °C</p>");


        });
    }


    if ($('.open-img').length) {
        /*        $('[data-fancybox="oldMap"]').fancybox({
                    protect: true,
                    buttons: [
                        'zoom',
                        'close'
                    ],
                    hash: false,
                    // animationEffect: "zoom-in-out",
                    // transitionEffect: "zoom-out",
                    hideScrollbar: true,
                    afterShow: function () {
                        hold_scroll_page(true);
                    },
                    afterClose: function () {
                        hold_scroll_page(false);
                    }
                });*/




        // Zoom Btn
        $.fancybox.defaults.btnTpl.zoomin = '<button data-fancybox-zoomin class="fancybox-button fancybox-button--zoomin" title="zoomin"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7,17.3l-3-3c1.7-2.3,1.4-5.6-0.6-7.6c-2.3-2.3-6-2.3-8.3-0.1c0,0,0,0-0.1,0.1C4.4,9,4.4,12.7,6.6,15c0,0,0,0,0.1,0.1 c2,2.1,5.3,2.4,7.7,0.7l3,3c0.4,0.3,0.9,0.3,1.3,0C19.1,18.3,19.1,17.8,18.7,17.3z M8.1,13.8c-1.6-1.6-1.6-4.1,0-5.7c0,0,0,0,0,0 c1.6-1.6,4.1-1.6,5.7,0c0,0,0,0,0,0c1.6,1.6,1.6,4.1,0,5.7c0,0,0,0,0,0C12.2,15.4,9.7,15.4,8.1,13.8C8.1,13.8,8.1,13.8,8.1,13.8z"/><path d="M12.5,11.9H9.4c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1h3.1c0.5,0,1,0.4,1,1v0C13.5,11.5,13,11.9,12.5,11.9z"/><path d="M10,12.5V9.4c0-0.5,0.4-1,1-1h0c0.5,0,1,0.4,1,1v3.1c0,0.5-0.4,1-1,1h0C10.4,13.5,10,13,10,12.5z"/></svg></button>';
        $.fancybox.defaults.btnTpl.zoomout = '<button data-fancybox-zoomout class="fancybox-button fancybox-button--zoomout" title="zoomout"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7,17.3l-3-3c1.7-2.3,1.4-5.6-0.6-7.6c-2.3-2.3-6-2.3-8.3-0.1c0,0,0,0-0.1,0.1C4.4,9,4.4,12.7,6.6,15c0,0,0,0,0.1,0.1 c2,2.1,5.3,2.4,7.7,0.7l3,3c0.4,0.3,0.9,0.3,1.3,0C19.1,18.3,19.1,17.8,18.7,17.3z M8.1,13.8c-1.6-1.6-1.6-4.1,0-5.7c0,0,0,0,0,0 c1.6-1.6,4.1-1.6,5.7,0c0,0,0,0,0,0c1.6,1.6,1.6,4.1,0,5.7c0,0,0,0,0,0C12.2,15.4,9.7,15.4,8.1,13.8C8.1,13.8,8.1,13.8,8.1,13.8z"/><path d="M12.5,11.9H9.4c-0.5,0-1-0.4-1-1v0c0-0.5,0.4-1,1-1h3.1c0.5,0,1,0.4,1,1v0C13.5,11.5,13,11.9,12.5,11.9z"/></svg></button>';

        $('[data-fancybox="oldMap"]').fancybox({
            touch: {
                vertical: false,
                momentum: false
            },
            buttons: [
                'zoom',
                'zoomout',
                'zoomin',
                'close'
            ],
            protect: true,
            afterShow: function () {
                hold_scroll_page(true);
            },
            afterClose: function () {
                hold_scroll_page(false);
            }
        });


        // zoom in
        $('body').on('click', '[data-fancybox-zoomin]', function () {
            fancyboxzoom('zoomin');
        });

        // zoom out
        $('body').on('click', '[data-fancybox-zoomout]', function () {
            fancyboxzoom('zoomout');
        });


        /*        $(window).bind('mousewheel', function(event) {
                    if($(".fancybox-spaceball").length) {
                        if (event.originalEvent.wheelDelta >= 0) {
                            fancyboxzoom('zoomout');
                        }
                        else {
                            fancyboxzoom('zoomin');
                        }
                        return false;
                    }
                });*/


        if (document.addEventListener) {
            document.addEventListener("mousewheel", MouseWheelHandler, false); //IE9, Chrome, Safari, Oper
            document.addEventListener("wheel", MouseWheelHandler, false); //Firefox
        } else {
            document.attachEvent("onmousewheel", MouseWheelHandler); //IE 6/7/8
        }


        function MouseWheelHandler() {
            if ($(".fancybox-spaceball").length) {
                e = window.event || e;
                var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.deltaY || -e.detail)));
                //scrolling down?
                if (delta < 0) {
                    fancyboxzoom('zoomout');
                }
                //scrolling up?
                else {
                    fancyboxzoom('zoomin');
                }
            }
        }
    }
    if ($('.modal').length) {
        $("#leave-review, #review-authorize, #new-event, #success").iziModal({
            closeButton: true,
            width: 630,
            radius: 0,
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown',
            /*    appendTo: '.site-wrapper',
                appendToOverlay: '.site-wrapper',*/
            onOpening: function () {
                $("input[type=tel]").mask("+38 (099) 999-99-99");
                hold_scroll_page(true);
            },
            onClosing: function () {


                let input = $(".modal .upload-file").find("input[type='file']"),
                    inputWrap = $(".modal .upload-file");
                input.replaceWith(input.val('').clone(true));
                inputWrap.removeClass("uploaded");
                inputWrap.find(".file-name").remove();
                $(".modal input, .modal textarea").val("");
                $(".modal .review-rating input[type='radio']").prop('checked', false);


                hold_scroll_page(false);
            }
        });
    }

    $('.upload-file label input[type="file"]').change(function () {
        let fileWrap = $(this).closest(".upload-file");
        fileWrap.addClass("uploaded");
        fileWrap.find("label").after("<div class='file-name'><p>" + $(this)[0].files[0].name + "<span class='icon-close'></span></p></div>")
    });

    $(document).on("click", ".file-name .icon-close", function () {
        let input = $(this).closest(".upload-file").find("input[type='file']"),
            inputWrap = $(this).closest(".upload-file");
        input.replaceWith(input.val('').clone(true));
        inputWrap.removeClass("uploaded");
        inputWrap.find(".file-name").remove();

    });

    $('.play-video button').click(function () {
        var src = $(this).parent(".play-video").data('src');
        $(".about-video iframe").remove();
        $(this).closest(".about-video").append('<iframe src="' + src + '?;autoplay=1&mute=1&enablejsapi=1&loop=1&showinfo=0&rel=0" frameborder="0" allowfullscreen></iframe>');
    });
    /*$(window).scroll(function () {
        if ($(".about-video iframe").length > 0) {
            $('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
    });*/

    /*$(".main-menu nav>ol>li>a").mouseenter(function () {
        if (window.innerWidth > 885) {
            $(".main-menu nav ol li").removeClass("open");
            $(this).closest("li").addClass("open");
        }
    });

    $(".main-menu nav").mouseleave(function () {
        if (window.innerWidth > 885) {
            $(".main-menu nav ol li").removeClass("open");
        }
    });*/

    var show = false;

    $(document).on('mouseenter', '.main-menu nav>ol>li>a', function () {
        if (window.innerWidth > 885) {
            show = true;
            var $this = $(this);
            setTimeout(function () {
                if (show) {
                    $(".main-menu nav ol li").removeClass("open");
                    $this.closest("li").addClass("open");
                }
            }, 500);
        }
    });

    $(document).on('mouseleave', '.main-menu nav>ol>li>a', function () {
        show = false;
    });

    // $(document).on('mouseleave', '.main-menu nav', function () {
    $(document).on('mouseleave', '.header-wrap', function () {
        if (window.innerWidth > 885) {
            $(".main-menu nav ol li").removeClass("open");
            $(this).closest("li").addClass("open");
            show = false;
        }
    });

    $(".main-menu nav ol li .drop-menu ol li a").mouseenter(function () {
        if (window.innerWidth > 885) {
            var imgSrc = $(this).data("img");
            $(this).closest(".drop-item").find(".drop-img img").attr("src", imgSrc);
        }
    });


    $(".menu-btn").click(function () {
        menuTrigger();
    });

    $(".main-menu nav ol li.drop-option>a").click(function (event) {
        let actItem = $(this).closest(".drop-option");
        if (window.innerWidth < 886) {
            event.preventDefault();
            if (actItem.hasClass("active")) {
                actItem.removeClass("active");
                actItem.find(".drop-item").slideUp();
            } else {
                actItem.addClass("active");
                actItem.find(".drop-item").slideDown();
            }
        }
    });

    $(window).resize(function () {
        if (!$(".header-bottom").hasClass("open-search")) {
            if ($(".menu-btn").hasClass("active")) {
                if (window.innerWidth < 886) {
                    hold_scroll_page(true);
                } else {
                    hold_scroll_page(false);
                }
            }
        }
    });


    $(".form-section").each(function () {

        $(this).find(".title label input").change(function () {
            if (this.checked) {
                $(this).closest(".form-section").find(".options label input").each(function () {
                    this.checked = true;
                })
            } else {
                $(this).closest(".form-section").find(".options label input").each(function () {
                    this.checked = false;
                })
            }
        });

        $(this).find(".options label input").click(function () {

            if ($(this).is(":checked")) {
                var isAllChecked = 0;
                $(this).closest(".form-section").find(".options label input").each(function () {
                    if (!this.checked)
                        isAllChecked = 1;
                });
                if (isAllChecked == 0) {
                    $(this).closest(".form-section").find(".title label input").prop("checked", true);
                }
            } else {
                $(this).closest(".form-section").find(".title label input").prop("checked", false);
            }
        });

    });

    $('.search-form label input').keyup(function () {
        if (!this.value.length) {
            if ($("body").hasClass("show-results")) {
                $("body").removeClass("show-results");
                $(".search-form button").removeClass("close-form");
                hold_scroll_page(false);
            }
        } else {
            if (!$("body").hasClass("show-results")) {
                $("body").addClass("show-results");
                $(".search-form button").addClass("close-form");
                hold_scroll_page(true);
            }
        }
    });


    $(document).on("click", ".header-search button, .search-form button.close-form", function () {
        searchTrigger();
    });

    $(document).on("click", ".map-filter, .sidebar-wrap.open-filter .form-btn .close", function () {
        triggerFilter();
    });

    /*$(document).on("click", ".map-places .card-description", function () {
        triggerPlace();
    });*/


    $(document).on("click", ".hide-sidebar, .open-sidebar .main-btn", function () {
        triggerSidebar()
    });

    $(document).on("click", ".map-places .card-description a, .project-address .map-item .title a", function (event) {
        event.preventDefault();
    });

    $(document).on("click", ".place-info.open .go-back p", function () {
        triggerPlace();
        if (currentInfoWindow != null) {
            currentInfoWindow.close();
        }
        deleteMarkers();
        returnMarkers();
        // addMarkers(markers_map, map)
    });

    $(document).on("click", ".map-places .card-description", function () {
        let indexElem = $(this).closest(".card-item");
        /*        $(".place-info").addClass("open");
                load_page($(this).find(".card-name a").attr("href"));*/
        activeIndex = indexElem.index();
        /*        map.setZoom(16);
                map.panTo(markers[activeIndex].getPosition());*/

        google.maps.event.trigger(markers[activeIndex], 'click');

    });

    $(".project-address .map-item").click(function () {
        let indexElem = $(this);
        activeIndex = indexElem.index();
        google.maps.event.trigger(markers[activeIndex], 'click');

    });


    seoButton();

    $(window).resize(function () {
        if ($(".text-overflow").length) {
            seoButton();

        }
    });


    $(document).on("click", ".more-text button", function () {
        let textWrap = $(this).closest(".text").find(".text-overflow"),
            curH = $(this).closest(".text").find(".text-height").innerHeight();
        if ($(this).hasClass("open")) {
            TweenMax.fromTo(textWrap, 0.3, {'max-height': curH + 'px',}, {
                'max-height': curHeight + 'px', ease: Power1.easeOut, onComplete: () => {
                    // textWrap.css('max-height', curHeight);
                    $(this).removeClass("open");
                },
            });
        } else {
            curHeight = textWrap.innerHeight();

            TweenMax.fromTo(textWrap, 0.3, {'max-height': curHeight + 'px',}, {
                'max-height': curH + 'px', ease: Power1.easeOut, onComplete: () => {
                    textWrap.css('max-height', '100%');
                    $(this).addClass("open");
                },
            });
        }
    });


});


